import { render, staticRenderFns } from "./StatisticsInjuries.vue?vue&type=template&id=0fc7eb5b&scoped=true"
import script from "./StatisticsInjuries.vue?vue&type=script&lang=js"
export * from "./StatisticsInjuries.vue?vue&type=script&lang=js"
import style0 from "./StatisticsInjuries.vue?vue&type=style&index=0&id=0fc7eb5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc7eb5b",
  null
  
)

export default component.exports